<template>
  <div class="bgClass">
    <div class="loginClass">
      <div class="logo">已加入NuMatch！</div>
      <div style="width: 100%; margin-top: 1%"></div>
      <div class="content">
        感謝您加入NuMatch！<br />閣下可選擇完善健康日誌以便今後獲取更專屬個性化訂製的<br />健康營養推薦！
      </div>
      <div style="width: 100%; margin-top: 1%"></div>
      <div class="half">
        <div style="width: calc(50% - 5px)">
          <el-select
            v-model="dynamicValidateForm.sex"
            class="m-2"
            placeholder="性別"
            size="large"
          >
            <el-option
              v-for="item in sexList"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </div>
        <div style="width: calc(50% - 5px); margin-left: 5px">
          <el-select
            v-model="dynamicValidateForm.age"
            class="m-2"
            placeholder="年龄"
            size="large"
          >
            <el-option
              v-for="item in ageList"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
        </div>
      </div>
      <div class="half">
        <div style="width: calc(50% - 5px)">
          <el-input v-model="dynamicValidateForm.height" placeholder="身高">
            <template #append>cm</template>
          </el-input>
        </div>
        <div style="width: calc(50% - 5px); margin-left: 5px">
          <el-input v-model="dynamicValidateForm.weight" placeholder="體重">
            <template #append>kg</template>
          </el-input>
        </div>
      </div>
      <div class="all">
          <el-select
            v-model="dynamicValidateForm.allergen"
            class="m-3"
            placeholder="過敏原（多選）"
            size="large"
            multiple
          >
            <el-option
              v-for="item in allergicList"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
      </div>
      <div class="all">
          <el-select
            v-model="dynamicValidateForm.flavor"
            class="m-3"
            placeholder="我的口味（多選）"
            size="large"
            multiple
          >
            <el-option
              v-for="item in menuList"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
      </div>
      <div class="all" style="height:40px;margin-bottom: 0px;margin-top:20px;">
          <el-select
            v-model="dynamicValidateForm.target"
            class="m-4"
            placeholder="健康目標"
            size="large"
          >
            <el-option
              v-for="item in habitList"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
      </div>
      <div class="all" style="height:40px;margin-bottom: 20px;margin-top:20px;">
          <el-select
            v-model="dynamicValidateForm.exercise"
            class="m-4"
            placeholder="運動習慣"
            size="large"
          >
            <el-option
              v-for="item in exerciseList"
              :key="item.uid"
              :label="item.name"
              :value="item.uid"
            />
          </el-select>
      </div>
      <div class="all" style="margin-top:0px;">
          <el-button id="otherBtn" round color="#6B834B" size="large" @click="submitForm">更新資訊</el-button>
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import Bottom from "../components/bottom/bottom.vue";
import { getDicList, addUserMessage, getUserMessage , getotherDic} from "../api/index";
// 
export default {
  name: "App",
  components: {
    Bottom,
  },
  setup() {
    const userRouter = useRouter();
    onMounted(() => {
      let a = window.localStorage.getItem('AIIndex_Token')
      if (a) {
        getUserMessages()
        getOtherMessage("exercise");
        getOtherMessage("age");
        getMessage("cchrAllergen");
        getMessage("cchrFlavor");
        getOtherMessage("healthGoal");
      } else {
        ElMessage.error('用戶未登錄')
          userRouter.push({
            name: 'Login',
            query: {},
          });
      } 
    });
    let sexList = ref([
      {label:'男',value: '男'},
      {label:'女',value: '女'},
    ]);
    let ageList = ref([]);
    let allergicList = ref([]);
    let menuList = ref([]);
    let habitList = ref([]);
    let exerciseList = ref([]);

    const dynamicValidateForm = ref({
      sex: "",
      age: "",
      height: "",
      weight: "",
      target: '',
      allergen: '',
      name: "",
      flavor: '',
      email: "",
      phone: "",
      exercise: '',
    });
    const getUserMessages = () => {
        let user = JSON.parse(window.localStorage.getItem('AIOrderIndex'))
        getUserMessage({}).then(
            (res) => {
                if (res.errCode == 200) {
                    dynamicValidateForm.value.userId = user.user_id
                    dynamicValidateForm.value.email = user.user_account
                    dynamicValidateForm.value.sex = res.data.sex
                    dynamicValidateForm.value.age = res.data.age
                    dynamicValidateForm.value.allergen = res.data.allergen != '' ? res.data.allergen.split(',') : ''
                    dynamicValidateForm.value.height = res.data.height + ''
                    dynamicValidateForm.value.weight = res.data.weight + ''
                    dynamicValidateForm.value.target = res.data.target
                    dynamicValidateForm.value.exercise = res.data.exercise
                    dynamicValidateForm.value.flavor = res.data.flavor != '' ? res.data.flavor.split(',') : ''
                } else {
                    ElMessage.error('獲取個人資訊失敗')
                }
            }
        )
    };

    const getMessage = (message) => {
      getDicList({ page: 1, size: 100000, primaryCode: message }).then(
        (res) => {
          if (res.errCode === 200) {
            if (res.data) {
              if (message == "cchrAllergen") {
                allergicList.value = res.data;
              } else if (message == "cchrFlavor") {
                menuList.value = res.data;
              }
            } else {
              ElMessage.error(res.errMsg);
            }
          }
        }
      );
    };

    const getOtherMessage = (message) => {
      getotherDic({ page: 1, size: 100000, type: message }).then(
        (res) => {
          if (res.errCode === 200) {
            if (res.data) {
              if (message == "exercise") {
                exerciseList.value = res.data.content;
              } else if (message == "age") {
                ageList.value = res.data.content;
              } else if (message == "healthGoal") {
                habitList.value = res.data.content;
              }
            } else {
              ElMessage.error(res.errMsg);
            }
          }
        }
      );
    };

    const submitForm = () => {
        let a = JSON.parse(JSON.stringify(dynamicValidateForm.value))
        a.allergen = a.allergen.join(',')
        a.flavor = a.flavor.join(',')
        addUserMessage(a).then(
        (res) => {
          if (res.errCode === 200) {
            ElMessage.success('資訊更新成功')
            userRouter.push({
              name: 'Home',
              query: {},
            });
          } else {
            ElMessage.error(res.errMsg);
            userRouter.push({
              name: 'Login',
              query: {},
            });
          }
        }
      ).catch((err)=>{
        console.log(err)
        userRouter.push({
              name: 'Login',
              query: {},
            });
      });

    };
    return {
      getOtherMessage,
      getMessage,
      sexList,
      ageList,
      allergicList,
      menuList,
      habitList,
      submitForm,
      dynamicValidateForm,
      userRouter,
      getUserMessages,
      exerciseList
    };
  },
};
</script>

<style lang="less" scoped>
.bgClass {
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
}
.loginClass {
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.logo {
  font-size: 32px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  line-height: 42px;
}
.content {
  font-size: 15px;
  font-family: MicrosoftYaHeiLight;
  color: #333333;
  span {
    font-family: PingFangSC-Medium, PingFang SC;
    color: black;
  }
}
.half {
  margin-top: 20px;
  width: calc(100% / 1080 * 258);
  display: flex;
  justify-content: space-between;
  height: 32px;
}
:deep(.el-input-group){
    height: 40px;
}
.all{
    margin-top: 20px;
    width: calc(100% / 1080 * 258);
    display: flex;
    justify-content: space-between;
    height: 63px;
}
.m-3{
    width: 100%;
    :deep(.el-input__wrapper){
        height: 63px;
    }
}
.m-4{
    width: 100%;
}
.orderBtn{
  width: 100%;
  height: 42px;
}

#otherBtn {
    width: 100%;
    height: 42px;
}
</style>